var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isLoading && _vm.currentServiceArea
        ? _c("display-categories", {
            attrs: {
              "current-service-area": _vm.currentServiceArea,
              "service-areas": _vm.standardCategories,
              "platform-category": _vm.platformCategory,
              "platform-category-name": _vm.platformCategoryName
            },
            on: { clickSARoute: _vm.clickSARoute }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.services
        ? _c("display-services", {
            attrs: {
              services: _vm.services,
              "platform-category": _vm.platformCategory
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dd683de2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd683de2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-browser/BrowseStandardService.vue
// module id = null
// module chunks = 